// extracted by css-extract-rspack-plugin
export default {"container":"Eg20KGoKjURXh0aJ","topWrapper":"yhVVNwAqSk8joy3j","btn":"caiTMMm2LWoHU8i6"};